import StyledTab from "@/views/components/StyledTab/StyledTab"
import CopyInfoHistory from "./CopyInfoHistory"
import classNames from 'classnames/bind'
import styles from './FollowerHistoryTransactionsComponent.module.scss'
import CalculationFeeHistory from "./CalculationFeeHistory"
import PNLHistoryFollower from "./PNLHistoryFollower"
import MoneyStatementFollower from "./MoneyStatementFollower"
import OrderHistoryFollower from "./OrderHistoryFollower"
import StocksStatementFollower from "./StocksStatementFollower"
import { useTranslation } from "react-i18next"
import useIsMobile from "@/componentShare/hooks/useIsMobile"
const cx = classNames.bind(styles);

type Props = any


export default function FollowerHistoryTransactionsComponent({ }: Props) {
    const { t } = useTranslation()
    const matches = useIsMobile();

    const TABS = [
        {
            label: t("copytrade.followerHistoryTransactions.orderHistory"),
            Panel: <OrderHistoryFollower />
        },
        {
            label: t("copytrade.followerHistoryTransactions.pnlHistory"),
            Panel: <PNLHistoryFollower />
        },
        {
            label: t("copytrade.followerHistoryTransactions.copyHistory"),
            Panel: <CopyInfoHistory />
        },
        {
            label: t("copytrade.followerHistoryTransactions.calcFeeHistory"),
            Panel: <CalculationFeeHistory />
        },
        {
            label: t("copytrade.followerHistoryTransactions.moneyStatement"),
            Panel: <MoneyStatementFollower />
        },
        {
            label: t("copytrade.followerHistoryTransactions.stocksStatement"),
            Panel: <StocksStatementFollower />
        },
    ]


    return (
        <div className={matches ? cx('history-transactions-component', "mobile") : cx('history-transactions-component')}>
            <StyledTab
                isFitHeight={true}
                tabs={TABS}></StyledTab>
        </div>
    )
}